<dialog #confirmModal class="confirm-dialog">
  <div class="confirm-dialog__box">
    <div class="confirm-dialog__header">
      <span class="material-symbols-outlined text-danger text-3xl" aria-hidden="true">warning</span>
      <h3 class="text-xl font-bold text-ink-800">האם אתה בטוח?</h3>
    </div>

    <p class="text-base text-ink-600 mt-2 leading-relaxed">
      פעולה זאת לא ניתנת לשינוי.
      <br />
      ההזמנה תימחק לחלוטין מההיסטוריה והיתרה תעודכן בהתאם.
    </p>

    <div class="mt-5 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
      <button
        type="button"
        class="btn-2026--ghost w-full sm:w-auto sm:min-w-[120px]"
        (click)="closeModal()"
        [disabled]="loading"
      >
        ביטול
      </button>
      <button
        type="button"
        class="btn-2026--danger w-full sm:w-auto sm:min-w-[160px]"
        (click)="onClick()"
        [disabled]="loading"
      >
        <span *ngIf="!loading" class="flex items-center gap-2 justify-center">
          <i class="material-symbols-outlined" aria-hidden="true">delete</i>
          מחק לצמיתות
        </span>
        <span *ngIf="loading">מוחק...</span>
      </button>
    </div>
  </div>
</dialog>
